module.exports = __webpack_public_path__ + "img/center.59d227d8.svg";